import Vue from 'vue';
import Vuex from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';
import { state, StoreState } from './states';
import { actions } from './actions';

Vue.use(Vuex);

// Make sure browser can support local storage

export default new Vuex.Store<StoreState>({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
});
